(function() { window.GUID_56bd3ca7_df9c_45e7_b77d_9891136efa95 = { getGuid: function() { return "56bd3ca7-df9c-45e7-b77d-9891136efa95"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let StatCompareSection;
        (function (StatCompareSection) {
            StatCompareSection[StatCompareSection["CSR"] = 0] = "CSR";
            StatCompareSection[StatCompareSection["ResultsAgainstEachOther"] = 1] = "ResultsAgainstEachOther";
            StatCompareSection[StatCompareSection["GameHistoryAgainstEachOther"] = 2] = "GameHistoryAgainstEachOther";
            StatCompareSection[StatCompareSection["WinRateAgainstSameOpponents"] = 3] = "WinRateAgainstSameOpponents";
            StatCompareSection[StatCompareSection["OverallResults"] = 4] = "OverallResults";
            StatCompareSection[StatCompareSection["ResultsInAnEvent"] = 5] = "ResultsInAnEvent";
            StatCompareSection[StatCompareSection["RacingBarChart"] = 6] = "RacingBarChart";
        })(StatCompareSection = Enumeration.StatCompareSection || (Enumeration.StatCompareSection = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=StatCompareSection.pre.js.map
